import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
 

@Component({ selector: 'events', templateUrl: 'events.component.html' })
export class EventsComponent implements OnInit, OnDestroy {
  
    constructor(private router: Router, ) { }

    ngOnInit() {
        // subscribe to new alert notifications
       
    }

    ngOnDestroy() { 
    }
 
}